import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-vehicle-tacho-slots',
  templateUrl: './vehicle-tacho-slots.component.html',
  styleUrls: ['./vehicle-tacho-slots.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleTachoSlotsComponent {

  @Output() public onChangeSlot$: EventEmitter<number> = new EventEmitter();
  @Input() public activeSlotIndex?: number;
  @Input() public slots?: any[] = [];

  @Input('tachoData') public set setTachoData(data: any) {
    if (data?.Time) {
      this.setLastUpdated(data.Time);
    }
  }

  public lastUpdated: number;

  constructor() { }

  public onClickSlot(index: number): void {
    this.onChangeSlot$.emit(index);
  }

  private setLastUpdated(date: string): void {
    const lastPositionTime:Date = new Date(date);
    const n = new Date();
    this.lastUpdated = Math.ceil((n.getTime() - lastPositionTime.getTime()) / 1000);
  }

}
